export default (params) => ({
  trigger: {
    name: 'out_of_stock_entrance.select_all_alternatives_below_element',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'select_all',
      params: {
        sub_feature: 'below_element',
      },
    },
    nonInt: true,
  },
});
